import Vue from "vue";
import VueChartList from "vue-chartist";
import "chartist/dist/chartist.min.css";

Vue.use(VueChartList);
